import { useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';
import { usePortletTranslations } from 'js/components/system/Portlet';

import { UNLIMITED_VALUE } from '../../constants';

export const useGetPendingLimitText = () => {
    const t = usePortletTranslations();
    const formatter = useFormatter();

    return useCallback((limit) => {
        const { timePeriod, limit: { amount, currencyCode } = {} } = limit;

        if (amount === UNLIMITED_VALUE) {
            return t('label.pending', [
                t(`field.${timePeriod}`),
                `´${t('placeholder.limit.unlimited')}´`
            ]);
        }

        return t('label.pending', [
            t(`field.${timePeriod}`),
            formatter.formatCurrency(amount, { currencyCode })
        ]);
    }, [t, formatter]);
};
